var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Header"},[_c('div',{staticClass:"content_box"},[(
        _vm.activity &&
        _vm.activity.store &&
        _vm.activity.store.logo &&
        _vm.activity.store.logo.path
      )?_c('img',{staticClass:"logo",attrs:{"src":_vm.activity.store.logo.path}}):_vm._e(),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.activity.store.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }